import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchBusinessDomain, updateBusinessDomain } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function BusinessKpiCreatePage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [domain, setDomain] = useState(null);
  const [form, setForm] = useState({ indicatorName: "", unit: "", measuringMethod: "", evaluationStandard: "", description: "" });

  useEffect(() => {
    (async () => {
      try { setDomain(await fetchBusinessDomain(businessDomainId)); }
      catch (e) { notify.apiError(e); }
    })();
  }, [businessDomainId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updated = { ...domain, indicators: [...(domain.indicators || []), form] };
      await updateBusinessDomain(updated);
      notify.success(t("message.create.success"));
      navigate(`/design/${businessDomainId}/business-kpis`);
    } catch (err) {
      notify.apiError(err);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("businessKpi.create.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required label={t("businessKpi.indicatorName")} name="indicatorName" value={form.indicatorName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth required label={t("businessKpi.unit")} name="unit" value={form.unit} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("businessKpi.measuringMethod")} name="measuringMethod" value={form.measuringMethod} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("businessKpi.evaluationStandard")} name="evaluationStandard" value={form.evaluationStandard} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("common.description")} name="description" value={form.description} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit" disabled={!domain}>{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/business-kpis`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
